import React, { useState, useEffect } from 'react';
import {
  useNewFinishAptitudeTestMutation,
  useNewUpdateResponsesAptitudeMutation,
} from '../NewAptitudeQuizSlice';
import Questions from './questions';

import AptitudeTestCardBar from '../layout/AptitudeTestCardBar';
import { useInterval } from 'hooks/useInterval';
import { useTimeout } from 'hooks/useTimeout';
import { useNavigate } from 'react-router-dom';
import { useGetUserQuery } from 'components/profile/userSlice';
import useNewAptitudeTestResponsesContext from 'hooks/useNewAptitudeTestResponseContext';

const Index: React.FC<{ data: any }> = ({ data }) => {
  // changed this: useNewUpdateResponsesAptitudeMutation , according to new aptitude slice
  const [updateResponsesAptitude] = useNewUpdateResponsesAptitudeMutation();
  const { state, dispatch } = useNewAptitudeTestResponsesContext();
  const [timeLeft, setTimeLeft] = useState(data.overallTimeLeft);
  // changed this: useNewFinishAptitudeTestMutation , according to new aptitude slice
  const [finishAptitudeTest, { isLoading }] =
    useNewFinishAptitudeTestMutation();

  const navigate = useNavigate();
  const { data: userData } = useGetUserQuery();
  const userEmail = userData?.email || '';

  const freeUser = [
    'mukesh@ingeniousfaces.com',
    'vayongceke2@gmail.com',
    'tshepangmpho@gmail.com',
  ].includes(userEmail);

  function finishTest() {
    finishAptitudeTest({})
      .unwrap()
      .then((res: any) => {
        navigate('/quiz/aptitude/scorecard');
      });
  }
  //Main timeout
  useTimeout(() => {
    if (data && data.overallTimeLeft && timeLeft < 0 && !freeUser) {
      finishTest();
    }
  }, timeLeft * 1000);

  useEffect(() => {
    updateResponsesAptitude({
      responses: state.responses,
      windowSwitch: state.tabSwitchedCount,
    });
  }, [state.responses, state.tabSwitchedCount, updateResponsesAptitude]);

  //Main Timer
  useInterval(() => {
    const minutesLeft = Math.floor(timeLeft / 60);
    const secondsLeft = timeLeft % 60;
    dispatch({
      type: 'UPDATE_REMAINING_TIME',
      payload: { minutesLeft, secondsLeft },
    });
    setTimeLeft((timeLeft: number) => timeLeft - 1);
  }, 1000);

  return isLoading ? (
    <p>Loading...</p>
  ) : (
    <div className='px-1 sm:px-4 lg:px-32 py-8 sm:py-16'>
      <AptitudeTestCardBar
        minutes={state.overallTimeLeft.minutes}
        seconds={state.overallTimeLeft.seconds}
      />
      <Questions />
    </div>
  );
};

export default Index;
